import { useState, useEffect } from 'react';
import { SyncOutlined } from '@ant-design/icons';

import { config } from '../config/config';

const { application } = config;

const PlayVideo = props => {
  const [ videoWidth, setVideoWidth ] = useState(480);
  const [ repeat, setRepeat ] = useState(false);
  const [api, setApi] = useState(application.url.prod);

  useEffect(() => {
    let screenWidth = window.screen.width;
    if (screenWidth > 480) {
      screenWidth = 480;
    }
    setVideoWidth(screenWidth);

    let apiConfig = application.url.prod;

    if (-~(window.location.hostname.indexOf('localhost'))) {
      apiConfig = application.url.local;
    }
    setApi(apiConfig);
  }, []);


  const styles = {
    video: {
      marginTop: 10,
      marginBottom: 40,
      maxWidth: 480,
      textAlign: 'center',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  };

  const poster = `/images/${props.type.type}.png`;

  const handleRepeat = id => {
    let newRepeat = !(!!repeat);
    setRepeat(newRepeat);
    let obj = document.getElementById(id);
    obj.loop = newRepeat;
  };

  return (
    <div style={styles.video}>
      <video controls width={videoWidth} poster={poster} id={props.type.type}>
        <source src={`${api}/video/${props.type.type}.mp4`} type="video/mp4" />
        <source src={`${api}/video/${props.type.type}.webm`} type="video/webm" />
        Sorry, your browser doesn't support embedded videos.
      </video>
      <div onClick={handleRepeat.bind(this, props.type.type)}>
        {
          repeat ? <SyncOutlined spin /> : <SyncOutlined />
        }
      </div>
    </div>
  )
};

export default PlayVideo;